import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { Badge } from "@webapp/badges/models/badges.models";
import { UiAvatarSize } from "@webapp/ui/avatar/avatar.models";
import { UiTooltipPlacement } from "@webapp/ui/tooltip/tooltip.models";

@Component({
  selector: "ui-badge-avatar",
  exportAs: "uiBadgeAvatar",
  templateUrl: "badge-avatar.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiBadgeAvatarComponent {
  @Input("uiBadge")
  public badge: Badge;

  @Input("uiSize")
  public size: UiAvatarSize = "md";

  @Input("uiShowTooltip")
  @InputBoolean()
  public showTooltip?: boolean;

  @Input("uiTooltipPlacement")
  public tooltipPlacement?: UiTooltipPlacement;
}
